module.exports = __webpack_public_path__ + "img/Background.5c17d92c.png";